import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterOption } from '../../models/filter-option.model';
import { CdkOverlayOrigin, ConnectedPosition } from '@angular/cdk/overlay';

@Component({
  selector: 'app-tree-menu',
  templateUrl: './tree-menu.component.html',
  styleUrl: './tree-menu.component.css'
})
export class TreeMenuComponent {

  @Input() options: FilterOption[] = [];
  @Input() searchable: boolean = false;
  
  @Output() selected = new EventEmitter();

  private filter = '';
  arregloMostrar: FilterOption[] = [];
  
  childrenOpen = false;
  currentOrigin?: CdkOverlayOrigin;
  currentChildren: FilterOption[] = [];
  currentFather: FilterOption;
  positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'top',

      overlayX: 'start',
      overlayY: 'top'
    }
  ];

  openChildren(
    option: FilterOption,
    origin: CdkOverlayOrigin
  ){
    if(!option.children?.length){
        this.childrenOpen = false;
        return;
    }

    this.currentOrigin = origin;
    this.currentChildren = option.children;
    this.currentFather = option;
    this.childrenOpen = true;
  }

  selection(item){
    if(item.children) return;
    this.selected.emit(item);
  }

  ngOnChanges(){
    if(this.currentFather){
      const fat = this.options.find(f => f.id === this.currentFather.id);
      this.currentChildren = fat.children;
    }
    this.arregloMostrar = [...this.options];

    if(this.filter !== ''){
      this.filtrado(this.filter);
    }
  }

  filtrado(filtrar){
    this.filter = filtrar;
    this.arregloMostrar = this.options.filter(e =>
      `${e.id}`.toLowerCase().includes(this.filter.toLowerCase())
    );
  }

}
